import { useTranslate } from "@similarweb/i18n-provider";
import { ItemIcon, Type } from "@similarweb/ui-components";

import { abbrNumberFilter } from "app/filters/ngFilters";
import { ALERTS_ITEM_TITLE } from "app/pages/activation/components/HomeWithData/Alerts/texts";
import { alertsDataAutomation } from "app/pages/activation/components/HomeWithData/dataAutomationKeys";
import { activationTracking } from "app/pages/activation/services/tracking";
import type { PriorityAlertItem } from "app/pages/activation/types/api";
import { AlertGroup, AlertVariant } from "app/pages/activation-alerts/types/PlatformAlerts";

import * as SC from "./styles";

type ItemSchema = {
    domainIcon: string;
    onClick: (alert: PriorityAlertItem) => void;
    alert: PriorityAlertItem;
};

const getTypeForTranslation = (variant: AlertVariant) =>
    variant === AlertVariant.NewPages ? "landing pages" : "keywords";

export const Item = ({ alert, domainIcon, onClick }: ItemSchema) => {
    const track = activationTracking.homePageWithData;
    const { translate } = useTranslate();
    const { totalAmount, alertsGroup, alertType, domain, insight } = alert;

    const generateTitle = () => {
        const num = abbrNumberFilter()(totalAmount);
        const typeOfTraffic = AlertGroup[alertsGroup];
        const type = getTypeForTranslation(alertType);

        return translate(ALERTS_ITEM_TITLE, { num, typeOfTraffic, alertType: type, domain });
    };

    const onItemClick = () => {
        track.trackViewAlert();

        onClick(alert);
    };

    return (
        <SC.Container
            onClick={onItemClick}
            $withRedirect
            data-automation={alertsDataAutomation.itemContainer}
        >
            <ItemIcon
                className="webIcon"
                iconSrc={domainIcon}
                iconType={Type.Website}
            />

            <SC.ContentContainer data-automation={alertsDataAutomation.itemContentContainer}>
                <SC.Title
                    fontVariant="captionTitle"
                    data-automation={alertsDataAutomation.itemTitle}
                >
                    {generateTitle()}
                </SC.Title>

                <SC.Content
                    data-automation={alertsDataAutomation.itemDescription}
                    dangerouslySetInnerHTML={{
                        __html: insight,
                    }}
                />
            </SC.ContentContainer>
        </SC.Container>
    );
};
